import React from 'react';

/**
 * A reusable section component for settings pages
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - The title of the section
 * @param {React.ReactNode} props.children - The content of the section
 * @param {string} [props.description] - Optional description for the section
 * @param {string} [props.className] - Optional additional CSS classes
 */
const SettingsSection = ({ title, children, description, className = '' }) => {
  return (
    <div className={`space-y-6 ${className}`}>
      <div>
        <h3 className="text-lg font-medium text-text-primary mb-4">{title}</h3>
        {description && (
          <p className="text-sm text-text-secondary mb-4">{description}</p>
        )}
        {children}
      </div>
    </div>
  );
};

export default SettingsSection;